<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <div class="handle-box" v-if="statusView=='S'">
        <el-row type="flex" align="middle">
          <el-button v-acl="RMC_PROT_MEDUSAGE_SAVE" v-if="detailInfo.status!='SUBMIT'&&statusView=='S'" size="mini" type="primary" @click="saveData('detailInfo')">保存</el-button>
          <el-button v-acl="RMC_PROT_MEDUSAGE_SUBMIT" v-if="statusView=='S'" size="mini" type="primary" @click="submitData('detailInfo')">提交</el-button>
          <el-button v-if="statusView=='S'&&!(detailInfo.category3Code=='10103'||(detailInfo.category3Code=='10101'&&$route.query.type=='Q'))" size="mini" type="primary" @click="onSum('detailInfo')">统计图表</el-button>
        </el-row>
      </div>

      <el-form :model="detailInfo" ref="detailInfo" :rules="rules" label-position="top" label-width="180px" class="labelPosTop">
        <div class="handle-box">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">基本信息</p>
            <p v-if="detailInfo.category3Code=='10101'">
              <span style="color: #606266;font-size: 13px;margin-right: 2px;">按养殖模式区分：</span>
              <el-select style="width: 200px;" v-model="breedingMode" clearable @change="calcWithBreedingMode">
                <el-option :key="index" v-for="(item,index) in breedingModeList" :label="item.object" :value="item.key"></el-option>
              </el-select>
            </p>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="报告期限" prop="reportDate">
                <el-select v-model="detailInfo.reportDate" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in reportDateLists" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="ASL Group" prop="aslGroupCode">
                <el-select v-model="detailInfo.aslGroupCode" :disabled="statusView!='S'?true:false" @change="getAslName" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.aslGroupName" :value="item.aslGroupCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Category3">
                <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" disabled style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in category3List" :label="item.label" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sponsor">
                <el-input disabled v-model="detailInfo.sponsorName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="状态">
                <ic-select table="TT_RMC_PROTEIN_MEDICINE_USAGE" disabled filterable field="STATUS" clearable v-model="detailInfo.status" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="麦当劳农场出栏量(只)" prop="mcdFarmCrapAmount">
                <el-input v-model="detailInfo.mcdFarmCrapAmount" maxlength="10" :disabled="statusView!='S'||detailInfo.category3Code=='10101'?true:false" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="麦当劳农场出栏量(重量,kg)" prop="mcdFarmCrapWeight">
                <el-input v-model="detailInfo.mcdFarmCrapWeight" @blur="setDosage" maxlength="10" :disabled="statusView!='S'||detailInfo.category3Code=='10101'?true:false" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="抗生素用量(mg/kg)(原粉量/出栏总重量)">
                <el-input v-model="detailInfo.antibioticsUsage" maxlength="10" disabled oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="HPCIA类抗生素使用量(mg/kg)(HPCIA抗生素原粉量/出栏总重量)">
                <el-input v-model="detailInfo.hpciaAntibioticsUsage" maxlength="10" disabled oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="detailInfo.category3Code=='10101'&&reportFreq=='M'">
              <el-form-item label="前7日抗生素使用量（mg/kg)">
                <el-input v-model="detailInfo.usageIn7Day" maxlength="10" disabled oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 只有月度的poultry才显示出栏信息 -->
        <div class="handle-box" style="margin-top:20px;" v-if="detailInfo.category3Code=='10101'&&reportFreq=='M'">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">出栏信息</p>
          </div>
          <el-row v-if="statusView=='S'" type="flex" style="margin-top:10px;">
            <el-button v-acl="RMC_PROT_MEDUSAGE_ITEM_UPDATE" class="btn" type="primary" @click="onAdd">新增</el-button>
            <el-button v-acl="RMC_PROT_MEDUSAGE_ITEM_UPDATE" :disabled="cropMultipleSelection.length>0?false:true" class="btn" type="danger" @click="delCropRow">删除</el-button>
            <el-button v-acl="RMC_PROT_MEDUSAGE_ITEM_UPDATE" class="btn" type="primary" @click="onImport">批量导入</el-button>
          </el-row>
          <el-table ref="cropRateListTable" :data="filteredCropRateList" @selection-change="cropSelectionChange" :row-class-name="tableRowClassName" style="margin-top:10px;" max-height="500" class="PQCP">
            <el-table-column type="index" align="center" label="序号" width="50">
              <template slot-scope="scope">
                {{(scope.$index+1)*10}}
              </template>
            </el-table-column>
            <el-table-column sortable type="selection" width="55" align="center" fixed="left"></el-table-column>
            <el-table-column align="center" width="130" label="屠宰场">
              <template>
                <span>{{detailInfo.aslGroupName}}</span>
                <!-- <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.rmcProteinAslId'" :rules="rmcProteinAslIdRules(scope.$index, scope.row)">
                  <el-select v-model="scope.row.rmcProteinAslId" @change="aslChange(scope.row)" clearable :disabled="statusView!='S'||!detailInfo.aslGroupCode?true:false" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in rmcProteinAslLists" :label="item.aslName" :value="item.rmcProteinAslId"></el-option>
                  </el-select>
                </el-form-item> -->
              </template>
            </el-table-column>
            <el-table-column label="农场名称" width="130" align="center" prop="rmcProteinFarmId" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.rmcProteinFarmId'" :rules="rmcProteinFarmIdRules(scope.$index, scope.row)">
                  <el-select v-model="scope.row.rmcProteinFarmId" @change="farmChange(scope.row)" clearable filterable :disabled="statusView!='S'||!detailInfo.aslGroupCode?true:false" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in rmcProteinFarmLists" :label="item.farmName" :value="item.rmcProteinFarmId"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="农场代码" width="120" align="center" prop="farmCode" show-overflow-tooltip></el-table-column>
            <el-table-column label="养殖模式" width="120" align="center" prop="farmBreedingMode" show-overflow-tooltip></el-table-column>
            <el-table-column label="农场出栏日期" width="150" align="center" prop="cropDate" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.cropDate'" :rules="cropDateRules(scope.$index, scope.row)">
                  <el-date-picker v-model="scope.row.cropDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" clearable :disabled="statusView!='S'?true:false" placeholder="选择日期" style="width:100%"></el-date-picker>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="130" align="center" prop="cropType" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.cropType'" :rules="cropTypeRules(scope.$index, scope.row)">
                  <ic-select v-model="scope.row.cropType" :disabled="statusView!='S'?true:false" clearable table="TT_RMC_PROTEIN_MEDICINE_USAGE_CROP_RATE" field="CROP_TYPE" style="width:100%"></ic-select>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 正整数 -->
            <el-table-column label="鸡群数量(只)" width="180" align="center" prop="cropQty" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.cropQty'" :rules="{required:true,message:'Can not be Empty!',trigger: 'blur'}">
                  <el-input v-model="scope.row.cropQty" @blur="cropQtyBlur" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" :disabled="statusView!='S'?true:false"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <!-- 两位小数 -->
            <el-table-column label="鸡群平均体重" width="120" align="center" prop="avgWeight" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.avgWeight'" :rules="{required:true,message:'Can not be Empty!',trigger: 'blur'}">
                  <el-input v-model="scope.row.avgWeight" @blur="avgWeightQtyBlur" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" :disabled="statusView!='S'?true:false"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="平均体重单位" width="130" align="center" prop="avgWeightUom" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.avgWeightUom'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                  <ic-select v-model="scope.row.avgWeightUom" :disabled="statusView!='S'?true:false" @change="avgWeightUomChange" clearable table="TT_RMC_PROTEIN_MEDICINE_USAGE_CROP_RATE" field="WEIGHT_UOM" style="width:100%"></ic-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="是否使用抗生素" width="130" align="center" prop="antibioticsUsed" :render-header="renderHeader">
              <template slot-scope="scope">
                <el-form-item label="" :prop="'cropRateList.' + scope.$index + '.antibioticsUsed'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                  <el-select v-model="scope.row.antibioticsUsed" clearable :disabled="statusView!='S'?true:false" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in usedIn7DayLists" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="药品用量明细数量" width="130" align="center" prop="medicineUsageCount"></el-table-column>
            <el-table-column label="原粉量汇总(kg)" width="130" align="center" prop="totalNetUsage"></el-table-column>
            <el-table-column label="7日龄内的原粉量汇总" width="130" align="center" prop="totalNetUsageIn7Day"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <el-form :model="medicForm" ref="medicForm">
        <div class="handle-box" style="margin-top:20px;">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <div class="info_title" v-if="statusView=='S'">
              <span>药品用量明细 </span>
              <span style="font-size: 12px;color:red" v-if="cropMultipleSelection.length!=1&&detailInfo.category3Code == '10101'&&reportFreq=='M'">请勾选出栏信息页签的行项目，然后才能维护药品用量明细；如果未勾选或者勾选了多行，则不可维护。</span>
              <span v-if="cropMultipleSelection.length===1&&detailInfo.category3Code == '10101'&&reportFreq=='M'">
                <span style="font-size: 12px;color:red">请维护：</span>
                <span style="font-size: 12px;color:red" v-if="!detailInfo.aslGroupCode&&!cropMultipleSelection[0].rmcProteinFarmId&&!cropMultipleSelection[0].cropDate">(空)</span>
                <span style="font-size: 12px;color:red" v-if="detailInfo.aslGroupCode">屠宰场：{{detailInfo.aslGroupName}}； </span>
                <span style="font-size: 12px;color:red" v-if="cropMultipleSelection[0].rmcProteinFarmId">农场：{{cropMultipleSelection[0].farmName}}； </span>
                <span style="font-size: 12px;color:red" v-if="cropMultipleSelection[0].cropDate">出栏日期：{{cropMultipleSelection[0].cropDate}}； </span>
                <span style="font-size: 12px;color:red" v-if="detailInfo.aslGroupCode||cropMultipleSelection[0].rmcProteinFarmId||cropMultipleSelection[0].cropDate"> 的药品用量</span>
              </span>
            </div>
            <div class="info_title" v-else>
              <span>药品用量明细 </span>
              <span style="font-size: 12px;color:red" v-if="cropMultipleSelection.length!=1&&detailInfo.category3Code == '10101'&&reportFreq=='M'">勾选出栏信息，即可查看与之对应的药品信息。</span>
            </div>
          </div>
          <el-row v-if="statusView=='S'&&((cropMultipleSelection.length==1&&detailInfo.category3Code == '10101'&&reportFreq=='M')||detailInfo.category3Code == '10103')" type="flex" style="margin-top:10px;" align="middle">
            <el-button v-acl="RMC_PROT_MEDUSAGE_ITEM_UPDATE" class="btn" type="primary" @click="addInventory">新增</el-button>
            <el-button v-acl="RMC_PROT_MEDUSAGE_ITEM_UPDATE" :disabled="multipleSelection.length>0?false:true" class="btn" type="danger" @click="delRow">删除</el-button>
          </el-row>
          <el-table ref="plxTable" :data="filteredAmountList" @selection-change="selectionChange" style="margin-top:10px;" max-height="500" show-overflow="ellipsis" highlight-current-row>
            <el-table-column type="index" align="center" label="序号">
              <template slot-scope="scope">
                {{(scope.$index+1)*10}}
              </template>
            </el-table-column>
            <el-table-column sortable type="selection" width="55" align="center" fixed="left"></el-table-column>
            <el-table-column label="药品代码" width="120" align="center" prop="medicineCode" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" width="130" label="药品一级分类" prop="medicineLevelOneGrade">
              <template slot-scope="scope">
                <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.medicineLevelOneGrade}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="WHO药品等级" width="130" align="center" prop="whoMedicineGrade"></el-table-column>
            <el-table-column label="商品名" width="130" align="center" prop="productName"></el-table-column>
            <el-table-column label="有效成分" show-overflow-tooltip align="center" prop="effectiveComponents"></el-table-column>
            <el-table-column label="净含量(%)(有效成分含量)" width="180" align="center" prop="netRate">
              <template slot="header">
                <span style="color:red;">*</span>
                <span>净含量(%)(有效成分含量)</span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="'amountList.' + scope.$index + '.netRate'" :rules="[{required:true,message:'Can not be Empty!',trigger: 'blur'},{ pattern: /^[0-9]+(\.[0-9]{0,2})?$/, message: '请输入数值'}]">
                  <el-input @blur="setNetUsage(scope.row)" v-model="scope.row.netRate" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" :disabled="statusView!='S'||(detailInfo.category3Code == '10101'&&cropMultipleSelection.length!==1)?true:false" placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="使用量(kg)" width="120" align="center" prop="usage">
              <template slot="header">
                <span style="color:red;">*</span>
                <span>使用量(kg)</span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="'amountList.' + scope.$index + '.usage'" :rules="{required:true,message:'Can not be Empty!',trigger: 'blur'}">
                  <el-input @blur="setNetUsage(scope.row)" v-model="scope.row.usage" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" :disabled="statusView!='S'||(detailInfo.category3Code == '10101'&&cropMultipleSelection.length!==1)?true:false" placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="换算原粉量(kg)(使用量*净含量%)" width="180" align="center">
              <template slot-scope="scope">
                <el-form-item :prop="'amountList.' + scope.$index + '.netUsage'">
                  <el-input disabled v-model="scope.row.netUsage" placeholder="请输入内容"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="抗生素是否在7日龄内使用" width="160" align="center" prop="usedIn7Day" v-if="detailInfo.category3Code=='10101'&&reportFreq=='M'">
              <template slot="header">
                <span style="color:red;">*</span>
                <span>抗生素是否在7日龄内使用</span>
              </template>
              <template slot-scope="scope">
                <el-form-item :prop="'amountList.' + scope.$index + '.usedIn7Day'" :rules="{required:true,message:'Can not be Empty!',trigger: 'change'}">
                  <el-select v-model="scope.row.usedIn7Day" @change="usedIn7DayChange" clearable :disabled="statusView!='S'||(detailInfo.category3Code == '10101'&&cropMultipleSelection.length!==1)?true:false" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in usedIn7DayLists" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div class="handle-box" style="margin-top:20px;">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">操作日志</p>
        </div>
        <el-table :data="tableData" style="width: 100%;margin-top:8px;" border>
          <el-table-column prop="createDate" label="操作时间" width="180"> </el-table-column>
          <el-table-column prop="operatorName" label="操作人" width="180"> </el-table-column>
          <el-table-column prop="action" label="操作描述"> </el-table-column>
          <el-table-column prop="comments" label="修改原因"> </el-table-column>
        </el-table>

      </div>
      <el-dialog title="药品清单" :visible.sync="dialogVisible" width="80%" :before-close="handleClose" class="fpa">
        <inventoryList v-if="dialogVisible" @close="handleClose"></inventoryList>
      </el-dialog>
      <el-dialog title="图表分析" :visible.sync="echartDialogShow" width="90%" :before-close="handleCloseEchart" class="fpa">
        <echartDialog v-if="echartDialogShow" @close="handleCloseEchart" :ttRmcProteinMedicineUsageId="ttRmcProteinMedicineUsageId"></echartDialog>
      </el-dialog>
      <el-dialog title="修改原因" :visible.sync="remarkDialogShow" width="40%" :before-close="handleCloseRemark" class="fpa">
        <el-form :model="remarkForm" ref="remarkForm">
          <el-form-item label="修改原因" prop="updateComments" :rules="remarkFormRules.updateComments">
            <el-input type="textarea" v-model="remarkForm.updateComments" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
          </el-form-item>
        </el-form>
        <el-row type="flex" justify="center" style="margin-top:10px">
          <el-button v-acl="RMC_PROT_MEDUSAGE_SUBMIT" size="mini" type="primary" @click="onConfirm">确认</el-button>
          <el-button size="mini" type="plain" @click="onCancel">取消</el-button>
        </el-row>
      </el-dialog>
      <el-dialog title="批量导入" :visible.sync="importDialogShow" width="40%" :before-close="handleCloseImport" class="fpa">
        <importDialog v-if="importDialogShow" :aslGroupCode="aslGroupCode" :cropRates="cropRates" :ttRmcProteinMedicineUsageId="ttRmcProteinMedicineUsageId" :sign="sign" @handleCloseImport="handleCloseImport" @closeImport="closeImport"></importDialog>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import proteinDrug from "@/api/rmcProtein/drug";
import commonFunction from "@/utils/dataTableUtils";
import inventoryList from '@/components/page/RMC/Protein/rmcDrugDosage/inventoryList'
import echartDialog from './echart.vue'
import aslApi from "@/api/rmcProtein/asl";
import medicineDosage from "@/api/rmcProtein/medicineDosage";
import importDialog from './import.vue'
const BigNumber = require('bignumber.js');
export default {
  name: '',
  components: {
    inventoryList,
    IcSelect,
    echartDialog,
    importDialog
  },
  data() {
    return {
      importDialogShow: false,
      remarkDialogShow: false,
      remarkForm: {
        updateComments: "",
      },
      tableData: [],//操作日志列表
      cropMultipleSelection: [],//出栏信息勾选框
      reportDateLists: [],//报告期限下拉框
      rmcProteinFarmLists: [], //农场名称下拉框
      avgWeightUomLists: [],// 平均体重单位下拉框
      aslGroupCodeList: [],
      dialogVisible: false,
      identity: localStorage.getItem('ms_emplFlag'),
      allDate: [],
      multipleSelection: [],
      categoryList2: [],
      categoryList3: [],
      statusList: [],
      usedIn7DayLists: [
        {
          value: 'Y',
          label: "是"
        },
        {
          value: 'N',
          label: "否"
        }
      ],
      detailInfo: {
        mcdFarmCrapAmount: null,
        mcdFarmCrapWeight: null,
        cropRateList: [],
        status: "DRAFT",
        category3Name: '',
        category3Code: '',
      },
      medicForm: {
        amountList: [],
      },
      category3List: [
        {
          key: "10101",
          label: "Poultry"
        },
        {
          key: "10103",
          label: "Pork"
        }
      ],
      isShow: false,
      showDetailDialog: false,
      formData: null,
      totalCount: "",
      statusView: "",
      remarkFormRules: {
        updateComments: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log("GY🚀 ~ file: detail.vue:324 ~ data ~ value:", value);
              if (!value) {
                return callback(new Error("请输入修改原因"));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      rules: {
        aslGroupCode: [
          { required: true, message: '请选择ASL Group', trigger: 'change' }
        ],
        reportDate: [
          { required: true, message: '请选择报告期限', trigger: 'change' }
        ],
        mcdFarmCrapAmount: [
          { required: true, message: '请输入麦当劳农场出栏量(只)', trigger: ['blur', 'change'] }
        ],
        mcdFarmCrapWeight: [
          { required: true, message: '请输入麦当劳农场出栏量(重量,kg)', trigger: ['blur', 'change'] }
        ],
        // netRate: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value === '') {
        //         callback(new Error('请输入净含量(%)'));
        //       } else {
        //         var reg = /^0(0+)|[^\d\.]+/
        //         console.log("GY🚀 ~ file: detail.vue:377 ~ data ~ reg.test(value):", reg.test(value));
        //         if (reg.test(value)) {
        //           callback(new Error('请输入数值'));
        //         }
        //         callback();
        //       }
        //     },
        //     trigger: 'blur'
        //   }
        // ],
        // usage: [
        //   { required: true, message: '请输入使用量(kg)', trigger: 'blur' }
        // ],
        // usedIn7Day: [
        //   { required: true, message: '请选择抗生素是否在7日龄内使用', trigger: 'change' }
        // ],
      },
      echartDialogShow: false,
      indices: null,
      sign: "",
      ttRmcProteinMedicineUsageId: "",
      cropRates: null,
      netUsageTotal: 0,
      netUsageTotalHpci: 0,
      netUsageTotal7Days: 0,
      medicineDelId: "",
      category: '',
      reportFreq: "",
      aslGroupCode: "",
      isUnique: false,
      operationType: "",

      breedingModeList: [],
      breedingMode: "ALL"
    }
  },
  computed: {
    // 过滤出栏信息只有viewable=true的数据才显示
    filteredCropRateList() {
      return this.detailInfo.cropRateList.filter(item => item.viewable === true);
    },
    // 过滤药品用量明细只有viewable=true的数据才显示
    filteredAmountList() {
      return this.medicForm.amountList.filter(item => !('viewable' in item) || item.viewable);
    },
    antibioticTotalNetUsage: function () {
      return this.detailInfo.cropRateList.reduce((accumulator, currentItem) => {
        if (currentItem.amountList && currentItem.amountList.length > 0) {
          return accumulator + currentItem.amountList.reduce((acc, item) => {
            // acc + item.netUsage
            return acc + (item.medicineLevelOneGrade == '抗生素' ? Number(item.netUsage) : 0)
          }, 0);
        }
      }, 0);
    },
    hpciTotalNetUsage: function () {
      return this.detailInfo.cropRateList.reduce((accumulator, currentItem) => {
        if (currentItem.amountList && currentItem.amountList.length > 0) {
          return accumulator + currentItem.amountList.reduce((acc, item) => {
            // acc + item.netUsage
            return acc + (item.whoMedicineGrade == 'HPCI' ? Number(item.netUsage) : 0)
          }, 0);
        }
      }, 0);
    },
    usedIn7DayNetUsage: function () {
      return this.detailInfo.cropRateList.reduce((accumulator, currentItem) => {
        if (currentItem.amountList && currentItem.amountList.length > 0) {
          return accumulator + currentItem.amountList.reduce((acc, item) => {
            return acc + (item.usedIn7Day == 'Y' ? Number(item.netUsage) : 0)
          }, 0);
        }
      }, 0);
    }
  },
  watch: {
    antibioticTotalNetUsage: {
      handler(newV) {
        console.log("GY🚀 ~ file: detail.vue:448 ~ handler ~ newV:", newV);
        if (newV) {
          this.netUsageTotal = newV
        }
      },
      immediate: true
    },
    hpciTotalNetUsage: {
      handler(newV) {
        console.log("GY🚀 ~ file: detail.vue:473 ~ handler ~ newV:", newV);
        if (newV) {
          this.netUsageTotalHpci = newV
        }
      },
      immediate: true
    },
    usedIn7DayNetUsage: {
      handler(newV) {
        console.log("GY🚀 ~ file: detail.vue:483 ~ handler ~ newV:", newV);
        if (newV) {
          this.netUsageTotal7Days = newV
        }
      },
      immediate: true
    }
  },
  created() {
    // this.getdCategory3()
    this.getBreedingModeList();
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      if (ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") != -1) {
        this.statusView = 'C'
      }
    }
    if (this.$route.query.type) {
      this.reportFreq = this.$route.query.type
    }
    this.category = this.reportFreq == 'M' ? 'Poultry' : 'Pork'
    this.detailInfo.category3Code = this.reportFreq == 'Q' ? '10103' : '10101'
    this.detailInfo.category3Name = this.reportFreq == 'Q' ? 'Pork' : 'Poultry'
  },
  mounted() {
    if (!this.$route.query.id) {
      this.getReportDateOptions()
      this.getSponsorByUser()
    }
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id)
      this.getReportDateOptions()
    }
  },
  methods: {
    // 获取养殖模式
    getBreedingModeList() {
      medicineDosage.getBreedingModeList().then(res => {
        this.breedingModeList = res?res:[];
      })
    },
    // 获取详情信息
    getDetail(id) {
      medicineDosage.medicineUsageDetail(id).then((res) => {
        console.log("GY🚀 ~ file: detail.vue:487 ~ medicineDosage.medicineUsageDetail ~ res:", res);
        if (res.code == '200') {
          this.detailInfo = res.data
          if (this.$route.query.sign == 'copy') {
            this.detailInfo.reportDate = ''
            this.detailInfo.status = ''
          }
          if (this.$route.query.sign == 'edit') {
            this.getOperationLog(res.data.ttRmcProteinMedicineUsageId)
          }
          this.ttRmcProteinMedicineUsageId = res.data.ttRmcProteinMedicineUsageId
          this.cropRates = JSON.stringify(res.data.cropRateList)
          if (this.detailInfo.category3Code == '10101' && this.reportFreq == 'M') {
            this.detailInfo.cropRateList = res.data.cropRateList ? res.data.cropRateList : []
            if (res.data.cropRateList && res.data.cropRateList.length > 0) {
              this.medicForm.amountList = []
              res.data.cropRateList.forEach(ele => {
                if (this.$route.query.sign == 'copy') {
                  ele.ttRmcProteinMedicineUsageCropRateId = ''
                }
                if (ele.amountList && ele.amountList.length > 0) {
                  ele.amountList.forEach(item => {
                    item.farmBreedingMode = ele.farmBreedingMode;
                    item.viewable = ele.viewable;
                    if (this.$route.query.sign == 'copy') {
                      ele.ttRmcProteinMedicineUsageAmountId = ''
                    }
                    this.medicForm.amountList.push(item)
                  })
                } else {
                  ele.amountList = []
                }
              })
            }
          }
          // todo
          if (this.detailInfo.category3Code == '10103' || (this.detailInfo.category3Code == '10101' && this.reportFreq == 'Q')) {
            this.detailInfo.cropRateList = []
            res.data.amountList.forEach(ele => {
              if (this.$route.query.sign == 'copy') {
                ele.ttRmcProteinMedicineUsageAmountId = ''
              }
            })
            this.medicForm.amountList = res.data.amountList ? res.data.amountList : []
          }
          console.log(' this.detailInfo.cropRateList', this.detailInfo.cropRateList)
          console.log(' this.medicForm.amountList', this.medicForm.amountList)
          this.getAslGroup(res.data.sponsorCode, res.data.aslGroupCode)

          this.getProteinFarmLists(res.data.aslGroupCode)
          setTimeout(() => {
            if (this.$route.query.sign == 'copy') {
              this.ttRmcProteinMedicineUsageId = ''
            }
          }, 1000);
        }
      })
    },
    // Poultry相关计算逻辑
    // 1,麦当劳农场出栏量(只)=出栏信息的鸡群数量
    cropQtyBlur() {
      let breedingMode = this.breedingMode;
      let mcdFarmCrapAmountSum = 0;
      if(breedingMode === "ALL") {
        mcdFarmCrapAmountSum = this.detailInfo.cropRateList.reduce((total, item) => {
          return total + (item.cropQty ? Number(item.cropQty) : 0)
        }, 0)
      }
      if(breedingMode === "M6M12") {
        mcdFarmCrapAmountSum = this.detailInfo.cropRateList.filter(item => item.farmBreedingMode != "6MX").reduce((total, item) => {
          return total + (item.cropQty ? Number(item.cropQty) : 0)
        }, 0)
      }
      if(breedingMode === "M6MX") {
        mcdFarmCrapAmountSum = this.detailInfo.cropRateList.filter(item => item.farmBreedingMode === "6MX").reduce((total, item) => {
          return total + (item.cropQty ? Number(item.cropQty) : 0)
        }, 0)
      }
      // let mcdFarmCrapAmountSum = this.detailInfo.cropRateList.reduce((total, item) => {
      //   return total + (item.cropQty ? Number(item.cropQty) : 0)
      // }, 0)
      console.log("GY🚀 ~ file: detail.vue:482 ~ mcdFarmCrapAmountSum ~ mcdFarmCrapAmountSum:", mcdFarmCrapAmountSum);
      this.$set(this.detailInfo, 'mcdFarmCrapAmount', mcdFarmCrapAmountSum)
      this.avgWeightQtyBlur()
    },
    // 麦当劳农场出栏量(重量,kg)=鸡群数量*鸡群平均体重*平均体重单位（如果为磅则换算为千克，1磅=0.4535924kg，保留两位小数）
    avgWeightQtyBlur() {
      let breedingMode = this.breedingMode;
      let mcdFarmCrapWeightSum = 0;
      if(breedingMode === "ALL") {
        mcdFarmCrapWeightSum = this.detailInfo.cropRateList.reduce((total, item) => {
          return total + (item.avgWeightUom == 'POUND' ? (Number(item.avgWeight) * Number(item.cropQty) * 0.4535924) : item.avgWeightUom == 'KG' ? (Number(item.avgWeight) * Number(item.cropQty)) : 0)
        }, 0)
      }
      if (breedingMode === "M6M12") {
        mcdFarmCrapWeightSum = this.detailInfo.cropRateList.filter(item => item.farmBreedingMode != "6MX").reduce((total, item) => {
          return total + (item.avgWeightUom == 'POUND' ? (Number(item.avgWeight) * Number(item.cropQty) * 0.4535924) : item.avgWeightUom == 'KG' ? (Number(item.avgWeight) * Number(item.cropQty)) : 0)
        }, 0)
      }
      if (breedingMode === "M6MX") {
        mcdFarmCrapWeightSum = this.detailInfo.cropRateList.filter(item => item.farmBreedingMode === "6MX").reduce((total, item) => {
          return total + (item.avgWeightUom == 'POUND' ? (Number(item.avgWeight) * Number(item.cropQty) * 0.4535924) : item.avgWeightUom == 'KG' ? (Number(item.avgWeight) * Number(item.cropQty)) : 0)
        }, 0)
      }
      // let mcdFarmCrapWeightSum = this.detailInfo.cropRateList.reduce((total, item) => {
      //   return total + (item.avgWeightUom == 'POUND' ? (Number(item.avgWeight) * Number(item.cropQty) * 0.4535924) : item.avgWeightUom == 'KG' ? (Number(item.avgWeight) * Number(item.cropQty)) : 0)
      // }, 0)
      console.log("GY🚀 ~ file: detail.vue:547 ~ mcdFarmCrapWeightSum ~ mcdFarmCrapWeightSum:", mcdFarmCrapWeightSum);
      this.$set(this.detailInfo, 'mcdFarmCrapWeight', parseFloat(mcdFarmCrapWeightSum).toFixed(2))
      //  计算抗生素用量(mg/kg)(原粉量/出栏总重量)和HPCIA类抗生素使用量(g/kg)(HPCIA抗生素原粉量/出栏总重量)
      this.setDosage()
      // 计算 前7日抗生素使用量（mg/Kg)=7日龄内使用为是的行项目的换算原粉量之和/出栏量(重量,kg)
      this.setFormTotalNetUsageIn7Day() //~
    },
    // 平均体重单位变更计算
    avgWeightUomChange(val) {
      console.log("GY🚀 ~ file: detail.vue:571 ~ avgWeightUomChange ~ val:", val);
      if (val) {
        this.avgWeightQtyBlur()
      }
    },

    // 换算原粉量(kg)(使用量*净含量%)=净含量(%)(有效成分含量)/100*使用量(kg) 保留6位小数
    setNetUsage(row) {
      console.log("GY🚀 ~ file: detail.vue:776 ~ setNetUsage ~ row:", row);
      let num = 0
      if (row.netRate && row.usage) {
        const a = new BigNumber(row.netRate);
        const b = new BigNumber(100);
        const netRate = a.dividedBy(b)
        console.log("GY🚀 ~ file: detail.vue:580 ~ setNetUsage ~ netRate:", netRate.toString());
        let c = new BigNumber(netRate);
        let d = new BigNumber(row.usage);
        num = c.multipliedBy(d)
        console.log("GY🚀 ~ file: detail.vue:580 ~ setNetUsage ~ num:", num.toString());
        // this.$set(row, 'netUsage', num.toFixed(6))
        this.$set(row, 'netUsage', num.toString())
      }
      //  计算抗生素用量(mg/kg)(原粉量/出栏总重量)和HPCIA类抗生素使用量(g/kg)(HPCIA抗生素原粉量/出栏总重量)
      this.setDosage()
      // 计算出栏信息每一行的原粉量汇总=对应行项目下的药品用量换算原粉量汇总之和
      this.setTotalNetUsage()
      // 计算出栏信息每一行7日龄内的原粉量汇总
      this.setTotalNetUsageIn7Day()
      // 计算 前7日抗生素使用量（mg/Kg)
      this.setFormTotalNetUsageIn7Day() //~
    },
    // 计算抗生素用量(mg/kg)(原粉量/出栏总重量)和HPCIA类抗生素使用量(g/kg)(HPCIA抗生素原粉量/出栏总重量)
    setDosage() {
      var antibioticTotal = 0, hpciTotal = 0, antibioticsUsageNum = 0, hpciaAntibioticsUsageNum = 0
      let breedingMode = this.breedingMode;
      console.log('this.medicForm.amountList', this.medicForm.amountList)
      //这是Poultry
      if (this.detailInfo.category3Code == '10101' && this.reportFreq == 'M') {
        if(breedingMode === "ALL") {
          this.detailInfo.cropRateList.forEach(ele => {
            if (ele.amountList && ele.amountList.length > 0) {
              ele.amountList.forEach(item => {
                if (item.medicineLevelOneGrade == '抗生素') {
                  antibioticTotal += Number(item.netUsage)
                }
                if (item.whoMedicineGrade == 'HPCI') {
                  hpciTotal += Number(item.netUsage)
                }
              })
            }
          })
        }
        if(breedingMode === "M6M12") {
          this.detailInfo.cropRateList.filter(item => item.farmBreedingMode != "6MX").forEach(ele => {
            if (ele.amountList && ele.amountList.length > 0) {
              ele.amountList.forEach(item => {
                if (item.medicineLevelOneGrade == '抗生素') {
                  antibioticTotal += Number(item.netUsage)
                }
                if (item.whoMedicineGrade == 'HPCI') {
                  hpciTotal += Number(item.netUsage)
                }
              })
            }
          })
        }
        if(breedingMode === "M6MX") {
          this.detailInfo.cropRateList.filter(item => item.farmBreedingMode === "6MX").forEach(ele => {
            if (ele.amountList && ele.amountList.length > 0) {
              ele.amountList.forEach(item => {
                if (item.medicineLevelOneGrade == '抗生素') {
                  antibioticTotal += Number(item.netUsage)
                }
                if (item.whoMedicineGrade == 'HPCI') {
                  hpciTotal += Number(item.netUsage)
                }
              })
            }
          })
        }
        // this.detailInfo.cropRateList.forEach(ele => {
        //   if (ele.amountList && ele.amountList.length > 0) {
        //     ele.amountList.forEach(item => {
        //       if (item.medicineLevelOneGrade == '抗生素') {
        //         antibioticTotal += Number(item.netUsage)
        //       }
        //       if (item.whoMedicineGrade == 'HPCI') {
        //         hpciTotal += Number(item.netUsage)
        //       }
        //     })
        //   }
        // })
      }
      // 这是pork
      if (this.detailInfo.category3Code == '10103' || (this.detailInfo.category3Code == '10101' && this.reportFreq == 'Q')) {
        if(breedingMode === "ALL") {
          this.medicForm.amountList.forEach((v) => {
            if (v.medicineLevelOneGrade == '抗生素') {
              antibioticTotal += Number(v.netUsage)
            }
            if (v.whoMedicineGrade == 'HPCI') {
              hpciTotal += Number(v.netUsage)
            }
          })
        }
        if (breedingMode === "M6M12") {
          this.medicForm.amountList.filter(item => item.farmBreedingMode != "6MX").forEach((v) => {
            if (v.medicineLevelOneGrade == '抗生素') {
              antibioticTotal += Number(v.netUsage)
            }
            if (v.whoMedicineGrade == 'HPCI') {
              hpciTotal += Number(v.netUsage)
            }
          })
        }
        if (breedingMode === "M6MX") {
          this.medicForm.amountList.filter(item => item.farmBreedingMode === "6MX").forEach((v) => {
            if (v.medicineLevelOneGrade == '抗生素') {
              antibioticTotal += Number(v.netUsage)
            }
            if (v.whoMedicineGrade == 'HPCI') {
              hpciTotal += Number(v.netUsage)
            }
          })
        }
        // this.medicForm.amountList.forEach((v) => {
        //   if (v.medicineLevelOneGrade == '抗生素') {
        //     antibioticTotal += Number(v.netUsage)
        //   }
        //   if (v.whoMedicineGrade == 'HPCI') {
        //     hpciTotal += Number(v.netUsage)
        //   }
        // })
      }
      console.log('药品用量明细中药品一级分类是抗生素的换算原粉量总和', antibioticTotal)
      console.log('药品用量明细中WHO药品等级是HPCI的换算原粉量总和', hpciTotal)
      if (this.detailInfo.mcdFarmCrapWeight && antibioticTotal) {
        // 抗生素用量(mg/kg)(原粉量/出栏总重量)=换算原粉量(kg)(使用量*净含量%)累加和/麦当劳农场出栏量(重量,kg)*1000
        antibioticsUsageNum = (antibioticTotal / this.detailInfo.mcdFarmCrapWeight) * 1000 * 1000
        console.log("GY🚀 ~ file: detail.vue:583 ~ setDosage ~ antibioticsUsageNum:", antibioticsUsageNum);
        this.$set(this.detailInfo, 'antibioticsUsage', antibioticsUsageNum.toFixed(2))
        // HPCIA类抗生素使用量(g/kg)(HPCIA抗生素原粉量/出栏总重量)=换算原粉量(kg)(使用量*净含量%)累加和/麦当劳农场出栏量(重量,kg)*1000
        hpciaAntibioticsUsageNum = (hpciTotal / this.detailInfo.mcdFarmCrapWeight) * 1000 * 1000
        console.log("GY🚀 ~ file: detail.vue:587 ~ setDosage ~ hpciaAntibioticsUsageNum:", hpciaAntibioticsUsageNum);
        this.$set(this.detailInfo, 'hpciaAntibioticsUsage', hpciaAntibioticsUsageNum.toFixed(2))
      } else {
        this.$set(this.detailInfo, 'antibioticsUsage', 0)
        this.$set(this.detailInfo, 'hpciaAntibioticsUsage', 0)
      }
    },
    // 计算出栏信息每一行的原粉量汇总=对应行项目下的药品用量换算原粉量汇总之和
    setTotalNetUsage() {
      this.detailInfo.cropRateList.forEach(ele => {
        if (ele.amountList && ele.amountList.length > 0) {
          ele.totalNetUsage = ele.amountList.reduce((total, item) => {
            return total + Number(item.netUsage)
          }, 0)
          ele.totalNetUsage = ele.totalNetUsage.toFixed(2)
        } else {
          ele.totalNetUsage = 0
        }
      })
    },
    // 抗生素是否在7日龄内使用变更
    usedIn7DayChange() {
      this.setTotalNetUsageIn7Day()
      this.setFormTotalNetUsageIn7Day() //~
    },
    // 计算出栏信息7日龄内的原粉量汇总
    setTotalNetUsageIn7Day() {
      this.detailInfo.cropRateList.forEach(ele => {
        if (ele.amountList && ele.amountList.length > 0) {
          ele.totalNetUsageIn7Day = ele.amountList.reduce((total, item) => {
            return total + (item.usedIn7Day == 'Y' ? Number(item.netUsage) : 0)
          }, 0)
          ele.totalNetUsageIn7Day = ele.totalNetUsageIn7Day.toFixed(2)
        } else {
          ele.totalNetUsageIn7Day = 0
        }
      })
    },
    // 计算 前7日抗生素使用量（mg/Kg)=7日龄内使用为是的行项目的换算原粉量之和/出栏量(重量,kg)
    setFormTotalNetUsageIn7Day() {
      let breedingMode = this.breedingMode;
      // 使用reduce计算所有c属性的总和
      let netUsageTotal7Days = 0;
      if(breedingMode) {
        if(breedingMode === "ALL") {
          netUsageTotal7Days = this.detailInfo.cropRateList.reduce((sum, obj) => {
            return sum + obj.amountList.reduce((sumNested, nestedObj) => {
              return sumNested + (nestedObj.usedIn7Day == 'Y' && nestedObj.medicineLevelOneGrade == '抗生素' ? Number(nestedObj.netUsage) : 0);
            }, 0);
          }, 0);
        }
        if(breedingMode === "M6M12") {
          netUsageTotal7Days = this.detailInfo.cropRateList.filter(item => item.farmBreedingMode != '6MX').reduce((sum, obj) => {
            return sum + obj.amountList.reduce((sumNested, nestedObj) => {
              return sumNested + (nestedObj.usedIn7Day == 'Y' && nestedObj.medicineLevelOneGrade == '抗生素' ? Number(nestedObj.netUsage) : 0);
            }, 0);
          }, 0);
        }
        if(breedingMode === "M6MX") {
          netUsageTotal7Days = this.detailInfo.cropRateList.filter(item => item.farmBreedingMode === '6MX').reduce((sum, obj) => {
            return sum + obj.amountList.reduce((sumNested, nestedObj) => {
              return sumNested + (nestedObj.usedIn7Day == 'Y' && nestedObj.medicineLevelOneGrade == '抗生素' ? Number(nestedObj.netUsage) : 0);
            }, 0);
          }, 0);
        }
      } else {
        netUsageTotal7Days = this.detailInfo.cropRateList.reduce((sum, obj) => {
          return sum + obj.amountList.reduce((sumNested, nestedObj) => {
            return sumNested + (nestedObj.usedIn7Day == 'Y' && nestedObj.medicineLevelOneGrade == '抗生素' ? Number(nestedObj.netUsage) : 0);
          }, 0);
        }, 0);
      }
      console.log("GY🚀 ~ file: detail.vue:668 ~ netUsageTotal7Days ~ netUsageTotal7Days:", netUsageTotal7Days);
      if (netUsageTotal7Days && netUsageTotal7Days != 0 && this.detailInfo.mcdFarmCrapWeight) {
        var num = netUsageTotal7Days / this.detailInfo.mcdFarmCrapWeight * 1000 * 1000
        console.log("GY🚀 ~ file: detail.vue:674 ~ setFormTotalNetUsageIn7Day ~ num:", num);
        this.$set(this.detailInfo, 'usageIn7Day', parseFloat(num).toFixed(2))
      } else {
        this.$set(this.detailInfo, 'usageIn7Day', 0)
      }
    },
    ///////////////////////////////////////////////////
    onImport() {
      this.operationType = 'import'
      this.saveData('detailInfo')
    },

    handleCloseImport() {
      this.sign = ''
      this.operationType = ''
      this.importDialogShow = false
    },
    closeImport() {
      this.sign = ''
      this.importDialogShow = false
      this.getDetail(this.$route.query.id)
    },
    getOperationLog(ttRmcProteinMedicineUsageId) {
      medicineDosage.getOperationLog(ttRmcProteinMedicineUsageId).then((res) => {
        console.log("GY🚀 ~ file: detail.vue:666 ~ medicineDosage.getOperationLog ~ res:", res);
        if (res.code == '200') {
          this.tableData = res.data
        }
      })
    },
    // 获取报告期限下拉框
    getReportDateOptions() {
      medicineDosage.getReportDateOptions(this.reportFreq).then((res) => {
        console.log("GY🚀 ~ file: detail.vue:335 ~ medicineDosage.getReportDateOptions ~ res:", res);
        if (res.code == '200') {
          this.reportDateLists = res.data
        }
      })
    },
    // 获取Sponsor字段值,根据supplierCode获取ASL Group下拉值
    getSponsorByUser() {
      proteinDrug.getSponsorByUser().then((res) => {
        this.$set(this.detailInfo, "sponsorCode", res.data.supplierCode)
        this.$set(this.detailInfo, "sponsorName", res.data.supplierName)
        this.getAslGroup(res.data.supplierCode)
      })
    },
    //  获取农场名称下拉值
    getProteinFarmLists(aslGroup) {
      medicineDosage.getFarmOptions(aslGroup, this.category).then((res) => {
        console.log("GY🚀 ~ file: detail.vue:388 ~ medicineDosage.getFarmOptions ~ res:", res);
        this.rmcProteinFarmLists = res.data
      })
    },
    farmChange(row) {
      this.rmcProteinFarmLists.forEach(ele => {
        if (ele.rmcProteinFarmId == row.rmcProteinFarmId) {
          console.log('ele', ele)
          this.$set(row, 'rmcProteinFarmName', ele.farmName)
          this.$set(row, 'farmName', ele.farmName)
          this.$set(row, 'farmCode', ele.farmCode)
          this.$set(row, 'farmBreedingMode', ele.breedingModeView)
        }
      })
    },
    // 获取ASL Group下拉框
    getAslGroup(id, aslGroupCode) {
      aslApi.aslGroup({}, id).then((res) => {
        if (res.code == 200) {
          this.aslGroupCodeList = res.data
          var codeLists = res.data.map(ele => {
            return ele.aslGroupCode
          })
          if (!codeLists.includes(aslGroupCode) && this.$route.query.id) {
            this.aslGroupCodeList.push({
              aslGroupCode: this.detailInfo.aslGroupCode,
              aslGroupName: this.detailInfo.aslGroupName,
              enabled: false,
              sponsorCode: id,
            })
          }
          let name = this.aslGroupCodeList.filter((a) => { return a.aslGroupCode == val })
          this.$set(this.detailInfo, 'aslGroupName', name[0].aslGroupName)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // asl group change事件
    getAslName(val) {
      this.detailInfo.cropRateList.forEach(ele => {
        ele.rmcProteinFarmId = ""
      })
      let name = this.aslGroupCodeList.filter((a) => { return a.aslGroupCode == val })
      this.$set(this.detailInfo, 'aslGroupName', name[0].aslGroupName)
      this.getProteinFarmLists(val)
    },
    arePropsEqual(arr, keys) {
      console.log("GY🚀 ~ file: detail.vue:770 ~ arePropsEqual ~ keys:", keys);
      console.log("GY🚀 ~ file: detail.vue:770 ~ arePropsEqual ~ arr:", arr);
      var flag = arr.every((obj, index) => obj[keys[index]])
      console.log("GY🚀 ~ file: detail.vue:794 ~ arePropsEqual ~ flag:", flag);
      if (flag) {
        const keyMap = {};
        for (let i = 0; i < arr.length; i++) {
          const key = keys.map(k => {
            if (arr[i][k]) {
              return arr[i][k]
            }
          }).join('-'); // 将相关属性值合并为Key
          console.log("GY🚀 ~ file: detail.vue:798 ~ key ~ key:", key);
          if (keyMap[key]) {
            return true; // 如果Key已存在，则表示有重复
          }
          keyMap[key] = true; // 否则，将Key添加到映射中
        }
        console.log("GY🚀 ~ file: detail.vue:777 ~ arePropsEqual ~ keyMap:", keyMap);
        return false; // 如果没有重复，则函数返回false
      } else {
        return false; // 如果没有重复，则函数返回false
      }
    },
    rmcProteinFarmIdRules(index, row) {
      return (this.rules["rmcProteinFarmId"] = [
        {
          validator: (rule, value, callback) => {
            if (!row.rmcProteinFarmId) {
              return callback(new Error('Can not be Empty!'));
            }
            if (this.detailInfo.cropRateList.length > 1) {
              // 新增时校验如果农场名称+农场出栏日期+类型已存在行项目，则提示：出栏信息添加重复，请检查！
              if (row.rmcProteinFarmId && row.cropDate && row.cropType) {
                const combineValue = row.rmcProteinFarmId + row.cropDate + row.cropType;
                console.log("GY🚀 ~ file: detail.vue:831 ~ rmcProteinFarmIdRules ~ combineValue:", combineValue);
                const isUnique = this.detailInfo.cropRateList.some((item, i) => {
                  if (item.rmcProteinFarmId && item.cropDate && item.cropType) {
                    return (combineValue == item.rmcProteinFarmId + item.cropDate + item.cropType) && i != index
                  }
                });
                console.log("GY🚀 ~ file: detail.vue:838 ~ isUnique ~ isUnique:", isUnique);
                if (isUnique) {
                  return callback(new Error('出栏信息添加重复，请检查！'));
                } else {
                  this.$refs.detailInfo.clearValidate([`cropRateList.${index}.rmcProteinFarmId`, `cropRateList.${index}.cropDate`, `cropRateList.${index}.cropType`])
                }
              }
              //   // var flag = this.arePropsEqual(this.detailInfo.cropRateList, ['rmcProteinFarmId', 'cropDate', 'cropType'])
              //   // console.log("GY🚀 ~ file: detail.vue:803 ~ rmcProteinFarmIdRules ~ flag:", flag);
              //   // if (flag) {
              //   //   return callback(new Error('出栏信息添加重复，请检查！'));
              //   // }
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    cropDateRules(index, row) {
      return (this.rules["cropDate"] = [
        {
          validator: (rule, value, callback) => {
            if (!row.cropDate) {
              return callback(new Error('Can not be Empty!'));
            }
            if (this.detailInfo.cropRateList.length > 1) {
              // 新增时校验如果农场名称 + 农场出栏日期 + 类型已存在行项目，则提示：出栏信息添加重复，请检查！
              if (row.rmcProteinFarmId && row.cropDate && row.cropType) {
                const combineValue = row.rmcProteinFarmId + row.cropDate + row.cropType;
                console.log("GY🚀 ~ file: detail.vue:831 ~ rmcProteinFarmIdRules ~ combineValue:", combineValue);
                const isUnique = this.detailInfo.cropRateList.some((item, i) => {
                  if (item.rmcProteinFarmId && item.cropDate && item.cropType) {
                    return (combineValue == item.rmcProteinFarmId + item.cropDate + item.cropType) && i != index
                  }
                });
                console.log("GY🚀 ~ file: detail.vue:838 ~ isUnique ~ isUnique:", isUnique);
                if (isUnique) {
                  return callback(new Error('出栏信息添加重复，请检查！'));
                } else {
                  this.$refs.detailInfo.clearValidate([`cropRateList.${index}.rmcProteinFarmId`, `cropRateList.${index}.cropDate`, `cropRateList.${index}.cropType`])
                }
              }
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    cropTypeRules(index, row) {
      return (this.rules["cropType"] = [
        {
          validator: (rule, value, callback) => {
            if (!row.cropType) {
              return callback(new Error('Can not be Empty!'));
            }
            if (this.detailInfo.cropRateList.length > 1) {
              // 新增时校验如果农场名称+农场出栏日期+类型已存在行项目，则提示：出栏信息添加重复，请检查！
              if (row.rmcProteinFarmId && row.cropDate && row.cropType) {
                const combineValue = row.rmcProteinFarmId + row.cropDate + row.cropType;
                console.log("GY🚀 ~ file: detail.vue:831 ~ rmcProteinFarmIdRules ~ combineValue:", combineValue);
                const isUnique = this.detailInfo.cropRateList.some((item, i) => {
                  if (item.rmcProteinFarmId && item.cropDate && item.cropType) {
                    return (combineValue == item.rmcProteinFarmId + item.cropDate + item.cropType) && i != index
                  }
                });
                console.log("GY🚀 ~ file: detail.vue:838 ~ isUnique ~ isUnique:", isUnique);
                if (isUnique) {
                  return callback(new Error('出栏信息添加重复，请检查！'));
                } else {
                  this.$refs.detailInfo.clearValidate([`cropRateList.${index}.rmcProteinFarmId`, `cropRateList.${index}.cropDate`, `cropRateList.${index}.cropType`])
                }
              }
            }
            callback();
          },
          trigger: "change"
        }
      ]);
    },
    // 根据id找到屠宰场名称和农场名称
    onAdd() {
      if (!this.detailInfo.aslGroupCode) {
        this.$message.error('请先选择基本信息的ASL Group后再进行新增')
        return false
      }
      var item = {
        rmcProteinFarmId: "",
        rmcProteinFarmName: "",
        cropDate: "",
        cropType: "",
        cropQty: "",
        avgWeight: "",
        avgWeightUom: "KG",
        medicineUsageCount: "",
        totalNetUsage: "",
        totalNetUsageIn7Day: "",
        amountList: [],
        ttRmcProteinMedicineUsageCropRateId: null,
        antibioticsUsed: "Y"
      }
      this.saveCropRate(item)
    },
    // 新增出栏信息后就自动保存这条数据
    saveCropRate(item) {
      medicineDosage.saveCropRate(item).then(res => {
        console.log("GY🚀 ~ file: detail.vue:882 ~ saveCropRate ~ res:", res);
        if (res.code == '200') {
          this.detailInfo.cropRateList.push(res.data)
        }
      })
    },
    // 删除出栏信息
    delCropRow() {
      console.log('this.cropMultipleSelection', this.cropMultipleSelection)
      this.$confirm('请确认是否删除出栏信息及关联的药品用量信息？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          cropRateIds: []
        }
        this.cropMultipleSelection.forEach((v) => {
          params.cropRateIds.push(v.ttRmcProteinMedicineUsageCropRateId)
        })
        medicineDosage.deleteCropRate(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.detailInfo.cropRateList = this.detailInfo.cropRateList.filter((v) => {
              return params.cropRateIds.indexOf(v.ttRmcProteinMedicineUsageCropRateId) == -1
            })
            if (this.detailInfo.cropRateList.length > 0) {
              this.detailInfo.cropRateList.forEach(ele => {
                if (ele.amountList && ele.amountList.length > 0) {
                  ele.amountList.forEach(item => {
                    item.farmBreedingMode = ele.farmBreedingMode;
                    this.medicForm.amountList.push(item)
                  })
                } else {
                  ele.amountList = []
                }
              })
            }
            this.cropQtyBlur()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    // 勾选出栏信息
    cropSelectionChange(val) {
      console.log('this.detailInfo.cropRateList', this.detailInfo.cropRateList)
      this.indices = null
      this.cropMultipleSelection = val
      console.log("GY🚀 ~ file: detail.vue:467 ~ cropSelectionChange ~ this.cropMultipleSelection:", this.cropMultipleSelection);
      var ttRmcProteinMedicineUsageCropRateIds = val.map(ele => ele.ttRmcProteinMedicineUsageCropRateId)
      console.log("GY🚀 ~ file: detail.vue:515 ~ cropSelectionChange ~ ttRmcProteinMedicineUsageCropRateIds:", ttRmcProteinMedicineUsageCropRateIds);
      // 如果只勾选了一行,那么药品用量可以新增和删除,那么获取当前的索引值,用来改变行项目下的药品用量数组
      if (val.length == 0) {
        this.medicForm.amountList = []
        this.detailInfo.cropRateList.forEach(ele => {
          if (ele.amountList && ele.amountList.length > 0) {
            ele.amountList.forEach(item => {
              item.farmBreedingMode = ele.farmBreedingMode;
              this.medicForm.amountList.push(item)
            })
          }
        })
      } else if (val.length == 1) {
        this.medicineDelId = val[0].ttRmcProteinMedicineUsageCropRateId
        console.log("为了药品用量明细删除时,删除cropRateList中amountLists的数据", this.medicineDelId);
        this.indices = val.map(item => this.detailInfo.cropRateList.indexOf(item));
        console.log("GY🚀 ~ file: detail.vue:520 ~ cropSelectionChange ~ this.indices:", this.indices);
        let amountList = val[0].amountList?val[0].amountList:[];
        amountList.forEach(item => {
          item.farmBreedingMode = val[0]?val[0].farmBreedingMode:"";
        });
        this.medicForm.amountList = amountList;
        // this.medicForm.amountList = val[0].amountList ? val[0].amountList : []
        console.log("GY🚀 ~ file: detail.vue:965 ~ cropSelectionChange ~ this.medicForm.amountList:", this.medicForm.amountList);
      } else if (val.length > 1) {
        // 如果选择多条,那么根据勾选的出栏信息将amountList合并展示
        this.medicForm.amountList = []
        val.forEach(ele => {
          if (ele.amountList && ele.amountList.length > 0) {
            ele.amountList.forEach(item => {
              item.farmBreedingMode = ele.farmBreedingMode;
              this.medicForm.amountList.push(item)
            })
          }
        })
      }
      console.log("GY🚀 ~ file: detail.vue:520 ~ cropSelectionChange ~ this.medicForm.amountList:", this.medicForm.amountList);
    },
    // 勾选药品用量明细
    selectionChange(val) {
      console.log("GY🚀 ~ file: detail.vue:696 ~ selectionChange ~ val:", val);
      this.multipleSelection = val
    },
    // 计算出栏信息药品用量明细数量=系统自动带出，对应行项目下的药品用量行项目数量
    setMedicineUsageCount() {
      this.detailInfo.cropRateList.forEach(ele => {
        if (ele.amountList) {
          ele.medicineUsageCount = ele.amountList.length
        }
      })
    },
    // 新增药品用量
    addInventory() {
      if (!this.detailInfo.aslGroupCode) {
        this.$message.error('请先选择ASL Group')
      } else {
        this.dialogVisible = true
        sessionStorage.setItem("rmcDrugDosageInfo", JSON.stringify(this.detailInfo))
      }
    },
    // 获取选择药品用量明细返回的数据
    handleClose(val) {
      console.log("选择药品用量明细返回的数据", val)
      console.log(' this.detailInfo.cropRateList111111111111', this.detailInfo.cropRateList)
      if (val && val.length > 0) {
        let params = {
          proteinMedicineList: val
        }
        medicineDosage.saveAmount(params).then((res) => {
          if (res.code == 200) {
            res.data.forEach((v) => {
              v.netRate = v.effectiveComponentsContent
              if(this.detailInfo.category3Code == '10101' && this.reportFreq == 'M') {
                v.farmBreedingMode = this.cropMultipleSelection[0].farmBreedingMode;
                v.viewable = this.cropMultipleSelection[0].viewable;
              }
            })
            // 如果是poultry,则要将选择的数据塞到cropRateList中
            if (this.detailInfo.category3Code == '10101' && this.reportFreq == 'M') {
              this.detailInfo.cropRateList.forEach((ele, i) => {
                // 找到当前勾选的出栏信息行项目
                if (i == this.indices[0]) {
                  if (ele.amountList) {
                    ele.amountList = ele.amountList.concat(res.data)
                  }
                }
              })
              if (this.medicForm.amountList && this.medicForm.amountList.length > 0) {
                this.medicForm.amountList = this.medicForm.amountList.concat(res.data)
              } else {
                this.medicForm.amountList = [...res.data]
              }
            }
            // 如果是pork,则直接合并
            if (this.detailInfo.category3Code == '10103' || (this.detailInfo.category3Code == '10101' && this.reportFreq == 'Q')) {
              if (this.medicForm.amountList && this.medicForm.amountList.length > 0) {
                this.medicForm.amountList = this.medicForm.amountList.concat(res.data)
              } else {
                this.medicForm.amountList = [...res.data]
              }
            }
            this.setMedicineUsageCount()
            console.log('this.detailInfo.cropRateList', this.detailInfo.cropRateList)
            console.log("GY🚀 ~ file: detail.vue:578 ~ medicineDosage.saveAmount ~ this.medicForm.amountList:", this.medicForm.amountList);
          }
        })
      }
      this.dialogVisible = false

    },
    // 删除药品用量
    delRow() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          amountIds: []
        }
        this.multipleSelection.forEach((v) => {
          params.amountIds.push(v.ttRmcProteinMedicineUsageAmountId)
        })

        // var 
        medicineDosage.deleteAmount(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.medicForm.amountList = this.medicForm.amountList.filter((v) => {
              return params.amountIds.indexOf(v.ttRmcProteinMedicineUsageAmountId) == -1
            })
            this.detailInfo.cropRateList.forEach(ele => {
              if (this.medicineDelId == ele.ttRmcProteinMedicineUsageCropRateId) {
                ele.amountList = ele.amountList.filter((v) => {
                  return params.amountIds.indexOf(v.ttRmcProteinMedicineUsageAmountId) == -1
                })
              }
            })
            console.log("GY🚀 ~ file: detail.vue:1145 ~ delRow ~ this.detailInfo.cropRateList:", this.detailInfo.cropRateList);
            //  计算抗生素用量(mg/kg)(原粉量/出栏总重量)和HPCIA类抗生素使用量(g/kg)(HPCIA抗生素原粉量/出栏总重量)
            this.setDosage()
            // 计算出栏信息药品用量明细数量=系统自动带出，对应行项目下的药品用量行项目数量
            this.setMedicineUsageCount()
            // 计算出栏信息每一行的原粉量汇总=对应行项目下的药品用量换算原粉量汇总之和
            this.setTotalNetUsage()
            // 计算出栏信息7日龄内的原粉量汇总
            this.setTotalNetUsageIn7Day()
            // 计算 前7日抗生素使用量（mg/Kg)=7日龄内使用为是的行项目的换算原粉量之和/出栏量(重量,kg)
            this.setFormTotalNetUsageIn7Day()
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    onDownload(val) {

    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === this.cur_index) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    // 保存
    saveData(formName) {
      let validateFields = ['reportDate', 'aslGroupCode']
      Promise.all(validateFields.map((item) =>
        new Promise((resove, reject) => {
          // 返回校验结果
          this.$refs[formName].validateField(item, (err) => resove(err))
        })
      )).then((res) => {
        console.log("GY🚀 ~ file: detail.vue:1079 ~ ).then ~ res:", res);
        // 过滤所有的非空串的，存在非空串表示校验不通过的
        if (res.filter((item) => item).length > 0) {
          this.$message.error('存在必填字段未填写完成，请检查。')
          return false
        }
        var flag = this.medicForm.amountList.some(ele => {
          var reg = /^0(0+)|[^\d\.]+/
          return reg.test(ele.netRate)
        })
        if (flag) {
          this.$message.error('请检查药品用量明细的净含量字段的值必须修改为数值格式，否则无法计算！')
          return false
        }
        // 校验通过后，业务逻辑
        if (this.detailInfo.category3Code == '10103') {
          this.detailInfo.amountList = this.medicForm.amountList
        }
        if (this.$route.query.sign == 'copy') {
          this.detailInfo.ttRmcProteinMedicineUsageId = ''
          this.detailInfo.cropRateList.forEach(ele => {
            ele.ttRmcProteinMedicineUsageId = ''
            if (ele.amountList.length > 0) {
              ele.amountList.forEach(item => {
                item.ttRmcProteinMedicineUsageId = ''
                item.ttRmcProteinMedicineUsageCropRateId = ''
                item.ttRmcProteinMedicineUsageAmountId = ''
              })
            }
          })
        }
        console.log("GY🚀 ~ file: detail.vue:1146 ~ ).then ~ this.detailInfo:", this.detailInfo);
        medicineDosage.saveMedicineUsage(this.detailInfo).then(async (res) => {
          console.log("GY🚀 ~ file: detail.vue:1074 ~ medicineDosage.saveMedicineUsage ~ res:", res);
          if (res.code == 200) {

            this.ttRmcProteinMedicineUsageId = res.data.ttRmcProteinMedicineUsageId
            this.reportFreq = res.data.reportFreq
            this.$router.replace({ path: '/rmcProtMedUsage/detail', query: { sign: 'edit', id: res.data.ttRmcProteinMedicineUsageId, type: this.reportFreq } });
            if (this.operationType == 'import') {
              try {
                await this.getDetail(res.data.ttRmcProteinMedicineUsageId)
                setTimeout(() => {
                  this.sign = 'batch'
                  this.aslGroupCode = this.detailInfo.aslGroupCode
                  this.cropRates = JSON.stringify(this.detailInfo.cropRateList)
                  this.importDialogShow = true
                }, 1000);
              } catch (error) {
                this.$message.error(error.message);
              }
            } else {
              this.$message.success("保存成功")
              this.getDetail(res.data.ttRmcProteinMedicineUsageId)
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    // 提交
    submitData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.detailInfo.category3Code == '10101' && this.reportFreq == 'M') {
            if (this.detailInfo.cropRateList.length == 0) {
              this.$message.error("请至少添加一行出栏信息")
              return false
            }
            for (let i = 0; i < this.detailInfo.cropRateList.length; i++) {
              const ele = this.detailInfo.cropRateList[i];
              if (ele.antibioticsUsed == 'Y' && ele.amountList.length == 0) {
                this.$message.error("出栏信息序号" + ((i + 1) * 10) + "是否抗生素为是，请至少维护一行药品用量明细！")
                return false
              }
              if (ele.antibioticsUsed == 'Y' && ele.amountList.length > 0) {
                for (let j = 0; j < ele.amountList.length; j++) {
                  const item = ele.amountList[j];
                  if (!item.netRate) {
                    this.$message.error("出栏信息序号" + ((i + 1) * 10) + "下药品用量明细,序号" + ((j + 1) * 10) + "下,净含量(%)不能为空")
                    return false
                  } else {
                    var reg = /^0(0+)|[^\d\.]+/
                    if (reg.test(item.netRate)) {
                      this.$message.error("出栏信息序号" + ((i + 1) * 10) + "下药品用量明细,序号" + ((j + 1) * 10) + "下,净含量(%)请输入数值")
                      return false
                    }
                  }
                  if (!item.usage) {
                    this.$message.error("出栏信息序号" + ((i + 1) * 10) + "下药品用量明细,序号" + ((j + 1) * 10) + "下,使用量(kg)不能为空")
                    return false
                  }
                  if (!item.usedIn7Day) {
                    this.$message.error("出栏信息序号" + ((i + 1) * 10) + "下药品用量明细,序号" + ((j + 1) * 10) + "下,抗生素是否在7日龄内使用不能为空")
                    return false
                  }
                }
              }
            }
          } else {
            if (this.medicForm.amountList.length == 0) {
              this.$message.error("请至少添加一行药品用量明细")
              return false
            }
          }
          this.$refs['medicForm'].validate((valid1) => {
            if (valid1) {
              if (this.detailInfo.status == 'SUBMIT') {
                this.remarkDialogShow = true
              } else {
                this.$confirm('是否确认提交?', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  if (this.detailInfo.category3Code == '10103') {
                    this.detailInfo.amountList = this.medicForm.amountList
                  }
                  medicineDosage.submitMedicineUsage(this.detailInfo).then((res) => {
                    if (res.code == 200) {
                      this.$message.success("提交成功")
                      this.routerBack()
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消提交'
                  });
                });
              }
            }
          })

          // this.setDosage()
          // if (this.detailInfo.amountList.length > 0) {
          //   medicineDosage.submitMedicineUsage(this.detailInfo).then((res) => {
          //     if (res.code == 200) {
          //       this.$message.success("提交成功")
          //       this.routerBack()
          //     } else {
          //       this.$message.error(res.msg)
          //     }
          //   })
          // } else {
          //   this.$message.error("请添加药品用量明细")
          // }

        } else {
          // return false;
          this.$message.error('存在必填字段未填写完成，请检查。')
        }
      });
    },
    onConfirm() {
      this.$refs['remarkForm'].validate((valid) => {
        if (valid) {
          this.setDosage()
          if (this.detailInfo.category3Code == '10103') {
            this.detailInfo.amountList = this.medicForm.amountList
          }
          this.$set(this.detailInfo, 'updateComments', this.remarkForm.updateComments)
          medicineDosage.submitMedicineUsage(this.detailInfo).then((res) => {
            if (res.code == 200) {
              this.$message.success("提交成功")
              this.routerBack()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    handleCloseRemark() {
      this.remarkDialogShow = false
    },
    onCancel() {
      this.remarkDialogShow = false
      this.remarkForm.updateComments = ''
    },
    // 统计图表
    onSum() {
      this.echartDialogShow = true
    },
    // 根据养殖模式统计农场出栏量/抗生素用量/前7日抗生素用量
    calcWithBreedingMode(val) {
      console.log(val)
      this.cropQtyBlur();
      // this.setDosage();
      // this.setFormTotalNetUsageIn7Day();
    },
    handleCloseEchart() {
      this.echartDialogShow = false
    },
    routerBack() {
      this.$router.back();
    },
    renderHeader(h, { column, $index }) {
      return h("span", [
        h("span", { class: "mandatory" }),
        h("span", column.label)
      ]);
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
/deep/ .el-table__body-wrapper .el-form-item__content {
  margin-left: 0px !important;
}
/deep/ .el-table__body-wrapper .searchForm .el-form-item--mini.el-form-item,
.searchForm .el-form-item--small.el-form-item {
  margin: 10px 0px !important;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  margin-left: 5px;
}
/deep/ .fpa .el-dialog__body {
  padding: 0px 20px 20px 20px !important;
}
</style>
